<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>
              <span style="color:#007BFFFF;">吴丰胜</span>
              <i class="el-icon-arrow-down icon"></i>
            </li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img">
            <img src="../../assets/img/top_logo.png" alt />
            <p>
              <span style="color:#999999FF;font-size:16px;">/</span> 个人中心
            </p>
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conent">
      <div class="conetn_1">
        <div class="conetn_left">
          <div class="conetn_left_1">
            <p>个人中心</p>
          </div>
          <ol class="conetn_left_2">
            <li>
              <!-- <img src="../../assets/img/geren/nav_btn_order_nor.png" alt /> -->
              <img src="../../assets/img/geren/nav_btn_order_sel.png" alt />
              <p>
                <a href="#" style="color:#007BFF;">我的订单</a>
              </p>
            </li>
            <li @click="dialogVisible = true">
              <img src="../../assets/img/geren/nav_btn_invoice_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的发票</a>
              </p>
            </li>
            <router-link :to="{path:'/zhinang',query:{token:this.$route.query.token}}" tag="li">
              <img src="../../assets/img/geren/nav_btn_znt_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的智囊团</a>
              </p>
            </router-link>
            <router-link :to="{path:'/tiwen',query:{token:this.$route.query.token}}" tag="li">
              <img src="../../assets/img/geren/nav_btn_ask_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的提问</a>
              </p>
            </router-link>
          </ol>
        </div>
        <div class="content_right">
          <div class="content_right_dd">
            <p>我的订单</p>
          </div>
          <div class="content_right_2">
            <!-- tab切换头部： -->
            <div class="content_right_top">
              <ul class="one">
                <li class="first" @click="wole()" :class="{active:num==0}">
                  <a href="#">全部订单</a>
                </li>
                <li @click="payment()" :class="{active:num==1}">
                  <a href="#">待付款</a>
                </li>
                <li @click="service()" :class="{active:num==2}">
                  <a href="#">服务中</a>
                </li>
                <li @click="evaluate()" :class="{active:num==3}">
                  <a href="#">待评价</a>
                </li>
                <li @click="end()" :class="{active:num==4}">
                  <a href="#">已结束</a>
                </li>
              </ul>
              <div class="right_right_cont">
                <input
                  type="text"
                  class="right_right"
                  placeholder="服务名称"
                  v-model="service_name"
                  @keydown="add"
                />
                <div class="search">
                  <img src alt />
                </div>
              </div>
            </div>
            <div class="content_right_cent">
              <ul>
                <li v-for="(item,index) in lists" :key="index">
                  <div class="right_top">
                    <p>{{item.create_time}}</p>
                    <p>{{item.order_sn}}</p>
                  </div>
                  <div class="content_right_li1">
                    <div class="imgg">
                      <img :src="item.avatar" alt />
                    </div>
                    <p class="pp1" style="padding: 0 20px;">{{item.service_name}}</p>
                    <p class="pp2">{{item.providers_name}}</p>
                    <p style="width:121px;">{{item.str_status}}</p>
                    <p @click="dingdang(item.id,item.order_status)">
                      <a href="#" style="color:#666">查看订单</a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="content_right_fenye">
              <el-pagination
                class="fenye"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                layout="prev, pager, next"
                :total="total"
              >
                <!-- @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page.sync="currentPage1" -->
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <div class="dialog">
        <img src="../../assets/img/geren/pop_QR.png" alt />
        <p>请前往小程序进行操作</p>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import { orderList } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      num: 0,
      total: 0,
      lists: [],
      nul: 0,
      dialogVisible: false,
      current_page: 1,
      service_name: ""
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    orderlist(page) {
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    wole(page, num) {
      this.num = 0;
      console.log(this.num);
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page, status: 0 }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    payment(page, num) {
      this.num = 1;
      console.log(this.num);
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page, status: 1 }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    service(page, num) {
      this.num = 2;
      console.log(this.num);
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page, status: 2 }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    evaluate(page, num) {
      this.num = 3;
      console.log(this.num);
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page, status: 3 }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    end(page, num) {
      this.num = 4;
      console.log(this.num);
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: page, status: 4 }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    add(service_name, page) {
      this.token = localStorage.getItem("token");
      orderList({
        token: this.token,
        page: page,
        service_name: this.service_name
      }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    dingdang(id, order_status) {
      if (order_status == "1") {
        this.$router.push({
          name: "dingdan",
          query: {
            id: id
          }
        });
      }
      if (order_status == "2") {
        this.$router.push({
          name: "yuwuzhong",
          query: {
            order_id: id
          }
        });
      }
      if (order_status == "3") {
        this.$router.push({
          name: "wangjie",
          query: {
            id: id
          }
        });
      }
      if (order_status == "4") {
        this.$router.push({
          name: "wangjie",
          query: {
            id: id
          }
        });
      }
    },
    handleCurrentChange(current_page) {
      this.current_page = current_page;
      this.orderlist(current_page);
      this.wole(current_page);
      this.payment(current_page);
      this.service(current_page);
      this.evaluate(current_page);
      this.end(current_page);
    }
  },
  created() {
    this.orderlist();
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 100px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}
.dialog {
  width: 28%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.dialog img {
  width: 168px;
  height: 168px;
  margin: 0 auto;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.content_right_top {
  width: 940px;
  height: 30px;
  /* border:1px solid red; */
  background: #ffffff;
  margin-top: 10px;
}
.content_right_top ul {
  width: 430px;
  height: 100%;
  float: left;
}
.content_right_top ul li {
  width: 56px;
  line-height: 24px;
  height: 24px;
  /* border:1px solid red; */
  float: left;
  margin-left: 30px;
  text-align: center;
}
.content_right_top ul li a {
  font-size: 13px;
  color: #222222;
  font-family: Microsoft YaHei;
}

.content_right_top ul li.active {
  border-bottom: 2px solid #007bff;
}
.right_right_cont {
  width: 221px;
  height: 30px;
  float: right;
}
.right_right {
  width: 80%;
  height: 80%;
}
.first {
  margin-left: 30px;
}
.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222ff;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.top_china {
  width: 100%;
  overflow: hidden;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.top_china_img p {
  float: left;
  line-height: 100px;
  font-size: 24px;
  font-weight: bold;
  color: #666666ff;
  margin-left: 15px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.conent {
  width: 100%;
  height: auto;
  background: #f4f5f9ff;
  overflow: hidden;
}

.conetn_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  margin-top: 30px;
}

.conetn_left {
  width: 240px;
  height: 284px;
  background: #fff;
  float: left;
}

.conetn_left_1 {
  width: 100%;
  height: 57px;
  border-bottom: 1px solid #e4e4e4ff;
}

.conetn_left_1 p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  padding: 18px 0 0 30px;
}

.conetn_left_2 {
  margin-top: 20px;
}

.conetn_left_2 li {
  width: 240px;
  height: 44px;
}

.conetn_left_2 img {
  float: left;
  padding: 14px 5px 0 29px;
}

.conetn_left_2 p a {
  float: left;
  line-height: 44px;
  font-size: 14px;
  color: #222222ff;
}

.content_right {
  width: 940px;
  height: auto;
  float: right;
}

.content_right_dd {
  width: 100%;
  height: 58px;
  border-bottom: 1px solid #e4e4e4;
  background: #ffffff;
}

.content_right_dd p {
  color: #222222;
  font-weight: 600;
  line-height: 58px;
  padding: 0 30px;
}

.content_right_2 {
  width: 100%;
  height: auto;
  background: #fff;
  margin-bottom: 144px;
  overflow: hidden;
}

.content_right_cent {
  width: 880px;
  height: 800px;
  margin: 20px auto;
}

.content_right_cent ul li {
  width: 100%;
  height: 120px;
  border: 1px solid #efefef;
  margin-top: 20px;
}

.right_top {
  width: 100%;
  height: 40px;
  background: #f5f6fa;
}

.right_top p {
  float: left;
  font-size: 14px;
  color: #666666;
  padding: 10px 19px;
}

.content_right_li1 {
  width: 880px;
  height: 82px;
}

.imgg {
  width: 60px;
  height: 60px;
  float: left;
  margin: 11px 0 0 19px;
}

.imgg img {
  width: 60px;
  height: 60px;
}

.content_right_li1 p {
  float: left;
  line-height: 82px;
  font-size: 14px;
  color: #666666;
  padding: 0 0 0 44px;
}

.pp1 {
  width: 234px;
  height: 82px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.content_right_li1 p:last-child {
  color: #000;
  font-weight: 400;
}

.content_right_fenye {
  width: 100%;
  height: 102px;
  overflow: hidden;
  text-align: center;
  padding: 35px 0;
}

.pp2 {
  width: 200px;
  height: 55px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.xiala {
  width: 100px;
  text-align: center;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/view/Geren/Dingdang.vue